import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import * as React from "react";
const CustomSelect = ({ ...props }) => {
  const {
    id,
    name,
    label,
    helperText,
    value,
    optionlist,
    fullWidth,
    sx,
    handleChangeFunction,
    onChange,
    small,
    className,
    ...selectProps
  } = props;
  let readonly = props.readonly;
  if (props.readonly == null || props.readonly == undefined) {
    readonly = false;
  }

  const [selectValue, setSelectValue] = React.useState(
    value !== null && value !== undefined && value !== "undefined" ? value : ""
  );
  const handleChange = (event: SelectChangeEvent) => {
    setSelectValue(event.target.value as string);
    handleChangeFunction && handleChangeFunction(event);
    onChange && onChange(event);
  };
  let selectStyle = sx
    ? sx
    : {
        "& .MuiSelect-select": {
          // padding: "8.5px 14px",
          padding: "12px 14px",
        },
        "& .MuiInputBase-readOnly": {
          background: "#e5e5e5",
        },
        width: small ? "90px" : "100%",
      };
  return (
    <Box>
      <FormControl fullWidth={!!fullWidth} sx={{ marginTop: "0px" }}>
        {label && (
          <InputLabel id="simple-select-standard-label">{label}</InputLabel>
        )}
        <Select
          id={id}
          name={name}
          value={value ?? ""}
          // defaultValue={selectValue}
          label={label}
          readOnly={readonly ? true : false}
          onChange={handleChange}
          fullWidth={!!fullWidth}
          {...selectProps}
          sx={selectStyle}
          className={className}
          displayEmpty
        >
          {optionlist.map(
            (option: { value: any; label?: string }, index: number) => (
              <MenuItem key={index} value={option.value}>
                {option.label && String(option.label).includes("-----") ? (
                  <span style={{ paddingLeft: "30px" }}></span>
                ) : option.label ? (
                  String(option.label).replace(/-----/g, "")
                ) : null}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CustomSelect;
